import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell } from '../grid';

type Props = { rows: any[]; loading?: boolean };

class HistoricalFactGrid extends React.PureComponent<Props> {

  columns: GridColDef[] = [
    { field: 'scenariocode', headerName: 'Scenario', width: 130 },
    { field: 'datasetcode', headerName: 'Dataset', width: 130 },
    { field: 'variablecode', headerName: 'Variable', width: 140 },
    { field: 'variablename', headerName: 'Name', flex: 1, minWidth: 240 },
    { field: 'periodcode', headerName: 'Period', width: 120 },
    { field: 'factcount', headerName: 'Facts', width: 100, type: 'number' },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 150,
      renderCell: FGridMoneyCell,
    },
  ];

  getRowId = (r: any) =>
    `${r.scenariocode}-${r.datasetcode}-${r.variablecode}-${r.periodcode}`;
  
  render() {
    return (
      <FDataGrid
        title="Published Historical Facts"
        subtitle="Read-only approved facts available to Forecast & Baseline."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={460}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#e7f6ea' }}
        getRowId={this.getRowId}
        pageSizeOptions={[25, 50, 100]}
      />
    );
  }
}

export default HistoricalFactGrid;
